import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import ro from './locales/ro.json';
import ru from './locales/ru.json';
import ua from './locales/ua.json';

/**
 * i18n bootstrap. Detection order matches v1: localStorage('i18nextLng') →
 * navigator → fallback 'en'. Macedonian is intentionally NOT registered
 * (PRD §5: v1 had the dir but never wired it).
 */
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ro: { translation: ro },
      ru: { translation: ru },
      ua: { translation: ua },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'ro', 'ru', 'ua'],
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;
